<template>
  <div :class="className + ' drop-down-menu'">
    <div class="active-box" @click="() => toggleOpen(!isOpen)">
      <div>{{ menu[active] ? menu[active].showText : '' }}</div>
      <i
        :class="
          isOpen
            ? 'iconfont iconicon_nav_downArrow open'
            : 'iconfont iconicon_nav_downArrow'
        "
      ></i>
    </div>
    <ul :style="{ height: isOpen ? reversedHeight : '0px' }">
      <li v-for="(item, index) in menu" :key="'ddm_' + index">
        <span v-if="active === index" @click="() => toggleOpen(false)">{{
          item.title
        }}</span>
        <router-link
          v-else
          :to="item.link"
          @click.native="() => toggleOpen(false)"
          >{{ item.title }}</router-link
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    menu: Array,
    className: String,
    active: Number
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    reversedHeight: function () {
      if (this.menu.length > 0) {
        return ((this.menu.length - 1) * 0.9 + 1.3) + 'rem';
      }
      return '0px';
    }
  },
  mounted() {
    if (this.menu.length > 0) {
      this.active = this.menu.findIndex(item => item.link === this.$route.path);
      console.log(this.active);
    }
  },
  watch: {
    $route(to, from) {
      console.log(to);
      this.active = this.menu.findIndex(item => item.link === to.path);
    }
  },
  methods: {
    toggleOpen(bool) {
      this.isOpen = bool;
    }
  }
};
</script>

<style lang="scss">
.drop-down-menu {
  .active-box {
    display: flex;
    justify-content: space-between;
    height: 0.9rem;
    line-height: 0.9rem;
    padding: 0 0.3rem;
    z-index: 2;
    font-size: 0.28rem;
    background: rgba(255, 255, 255, 0.96);
    .iconfont {
      transition: all 0.3s;
    }
    .open {
      transform: rotate(180deg);
    }
  }
  ul {
    background: rgba(255, 255, 255, 0.96);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    top: 1.9rem;
    width: 100%;
    padding: 0 0.32rem;
    font-size: 0.3rem;
    color: #333;
    z-index: 100;
    max-height: 0;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    max-height: 3.92rem;
    li {
      padding: 0 0 0.48rem;
      &:first-child {
        padding-top: 0.4rem;
      }
      a,
      span {
        display: block;
        height: 0.42rem;
        line-height: 0.42rem;
        color: #333;
        text-align: left;
      }
      span {
        color: #2a75ed;
      }
    }
  }
}
</style>
